<ngx-loading [show]="isProcessing"></ngx-loading>

<div class="row h670">

  <div class="col-md-8 h550">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Materiais Cadastrados</h3><br />
        <span class="text-muted">Selecione para editar</span>
        <div class="divider"></div>

        <div class="input-group input-group-sm">
          <input type="text" class="form-control" #parametro id="parametro" placeholder="busca" maxlength="30">
          <div class="input-group-append">
            <button class="btn btn-light" type="button" (click)="search(parametro.value)" title="buscar"><i
                class="fa fa-search pr-1 pl-1"></i></button>
          </div>
          <div class="input-group-append">
            <button class="btn btn-light" type="button" title="limpar/remover filtro" (click)="clearSearch()"><i
                class="fa fa-times pr-1 pl-1"></i></button>
          </div>
        </div>

      </div>

      <div class="box-body h400">

        <div class="box-table h350">
          <table style="font-size: 0.9em;">
            <thead>
              <tr>
                <th class="text-center wf90">Código</th>
                <th class="text-center w120">NCM</th>
                <th class="text-center wf120">Tipo Material</th>
                <th class="text-center">Descricao</th>
                <th class="text-center">Saldo</th>
                <th class="text-center">Valor (OS)</th>
                <th class="text-center">Valor <br />(Pr médio)</th>
                <th class="text-center">#</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of cadastrados" class="cp" 
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td class="text-center" (click)="getById(c.id)">{{ c.codigo }}</td>
                <td class="text-center" (click)="getById(c.id)">{{ c.ncm }}</td>
                <td (click)="getById(c.id)">{{ c.tipoMaterial }}</td>
                <td (click)="getById(c.id)">{{ c.descricao }}</td>
                <td class="text-center w60" (click)="getById(c.id)">{{ c.saldo.toLocaleString() }}</td>
                <td (click)="getById(c.id)" class="text-right">{{ c.valor.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) }}</td>
                <td (click)="getById(c.id)" class="text-right">{{ c.precoMedio ? c.precoMedio.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) : '' }} </td>
                <td class="cp text-center" (click)="getUltimasEntradasMaterias(c.id, modalUltimasEntradas)" [title]="this.titleUltimasEntradas">
                  <span class="fa fa-th-list fa-lg txt-blue"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="box-footer">
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
          <div>
            <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
            <span *ngIf="this.isFiltered" class="pl-3 text-primary">(filtrados)</span>
          </div>
          <button type="button" class="btn btn-light" (click)="exportarToExcel(parametro.value)"
            [disabled]="this.cadastrados.length == 0" title="Gera uma planilha Excel com os dados apresentados na grid">
            <span class="fa fa-table txt-green"></span>
            <span class="pl-2 pr-2">Exportar Excel</span>
          </button>
        </div>
        <div class="divider"></div>
        <div class="text-center mt-2" [class.highlight]="excelFileName !== ''" style="min-height: 30px;">
          <a *ngIf="excelFileName !== ''" [href]="hrefExcelFile">{{excelFileName}}</a>
        </div>

      </div>
    </div>
  </div>



  <div class="col-md-4">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }"
      style="height: 660px; padding: 20px;">

      <div class="box-body" style="height: 483px;">

        <form novalidate  [formGroup]="form" id="form" (validSubmit)="submit()">

          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Tipo Material</label>

                <select class="form-control" formControlName="tipoMaterialId" required>
                  <option value="">selecione</option>
                  <option *ngFor="let item of this.tiposMateriais" [value]="item.id">{{item.descricao}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Código</label>
                <div class="input-group">

                  <input class="form-control" formControlName="codigo" type="text" maxlength="10" required>
                  <div class="input-group-append cp" (click)="getNextCodigo()" title="Obter próximo código material">
                    <span class="input-group-text">
                      <i class="fa fa-refresh txt-blue" aria-hidden="true"></i>
                      <span class="pl-2">
                        Cód. aut.
                      </span>
                    </span>
                  </div>

                  <div class="row col-md-12">

                    <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                      <small *ngIf="form.get('codigo').hasError('isNotUniqueCodigo')">Este código já está uso</small>
                    </section>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-10">
              <div class="form-group">
                <label for="">NCM</label>
               
                  <input class="form-control" formControlName="ncm" type="text" maxlength="8" digitOnly>
                  <div class="row col-md-12">
                  <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                    <small *ngIf="form.get('ncm').hasError('isNotUniqueNCM')">Este NCM já está uso</small>
                    <small *ngIf="form.get('ncm').hasError('isSizeErrorNCM')">O NCM deve ter 8 dígitos</small>
                  </section>
                </div>
                
              </div>
            </div>
          </div>


          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Descrição</label>
                <textarea rows="5" class="form-control" formControlName="descricao" maxlength="200" required
                  style="resize: none"></textarea>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('descricao').hasError('isNotUniqueDescricao')">Esta descrição já está
                    uso</small>
                </section>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Valor OS</label>
                <div class="input-group">
                  <input currencyMask class="form-control" formControlName="valor" type="text" maxlength="13"
                    (blur)="blurValor()" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                  <div class="input-group-append cp" (click)="clearValor()" title="Limpar">
                    <span class="input-group-text bg-light"><i class="fa fa-times"></i></span>
                  </div>
                </div>
              </div>
            </div>
         
          </div>

          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Unidade</label>
                <div class="input-group">
                  <input class="form-control" formControlName="unidade" type="text" maxlength="10" required>
                </div>
              </div>
            </div>
          </div>


          <div class="form-row" *ngIf="this.form.get('precoMedio').value">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Valor Médio</label>
                <div class="input-group">
                  <input class="form-control text-right" type="text" disabled 
                  [value]="this.form.get('precoMedio').value.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})" >
                </div>
              </div>
            </div>
           
          </div>

        </form>

      </div>

    </div>

  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)" title="Exluir material selecionado"
                (click)="showModalSm(modaldelete)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="d-flex justify-content-center">
            <span class="question-modal pt-3 pb-3">Deseja excluir o <b>material</b> selecionado?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="delete(this.form.get('id').value, c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>




<ng-template #modalUltimasEntradas let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">
      Últimas entradas
    </h4>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        

        <div class="box-table" style="overflow-y: hidden;">
          <table>
            <tbody>
              <tr>
                <th colspan="2" class="text-center bg-light">Material</th>
              </tr>
              <tr>
                <th class="text-right wf120 pr-2 bg-light">Código</th>
                <td class="text-left pl-2">{{this.materialSelected.codigo}}</td>
              </tr>
              <tr>
                <th class="text-right wf120 pr-2 bg-light">Tipo Material</th>
                <td class="text-left pl-2">{{this.materialSelected.tipoMaterial}}</td>
              </tr>
              <tr>
                <th class="text-right wf120 pr-2 bg-light">Descricao</th>
                <td class="text-left pl-2">{{this.materialSelected.descricao}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="row" *ngIf="this.ultimasEntradas.length == 0">
      <div class="col-md-12 text-center p-4">
        <span class="text-warning fs14">
          <span class="fa fa-warning fa-lg pr-2 fb"></span> Este material não possui entradas
        </span>
      </div>
    </div>

   

    <section class="animated fadeInDown" *ngIf="this.ultimasEntradas.length > 0">
      <div class="row">
        <div class="col-md-12">
         
          <div class="box-table h250">
            <table>
              <thead>
                <tr>
                  <th>Data/Hora Entrada</th>
                  <th>Numero Documento</th>
                  <th>Quantidade</th>
                  <th>Valor</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr *ngFor="let entrada of this.ultimasEntradas" class="cp">
                  <td>{{ entrada.dataHoraEntrada | date:'dd/MM/yyyy HH:mm'}}</td>
                  <td>{{ entrada.numeroDocumento }}</td>
                  <td>{{ entrada.quantidade }}</td>
                  <td>{{ entrada.valor.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) }}</td>
                  <td>{{ entrada.total.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <div class="col-md-8"></div>

    <div class="col-md-4">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-light btn-shadow btn-block" (click)="c('Close click')">
          Fechar
        </button>
      </div>
    </div>
  </div>
</ng-template>
